<template>
  <v-card v-if="items.length" v-bind="$attrs">
    <v-system-bar color="warning">Änderungswünsche</v-system-bar>
    <PersonalTable
      :hidePerson="true"
      :items="items"
      :loading="loading"
      @updated="fetchData"
    ></PersonalTable>
  </v-card>
</template>
<script>
import { defineComponent } from "vue";
import PersonalTable from "@/views/OnBoarding/PersonalTable.vue";
export default defineComponent({
  components: { PersonalTable },
  props: ["id"],
  data() {
    return {
      loading: false,
      items: [],
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      if (!this.id) {
        this.items = [];
        this.loading = false;
        return;
      }
      this.items = await this.apiList({
        resource: "checkin/person",
        query: `creatorId=${this.id}`,
      });

      this.loading = false;
    },
  },
  watch: {
    async id() {
      this.fetchData();
    },
  },
  async created() {
    this.fetchData();
  },
});
</script>
